import {useMutation, useQuery, useQueryClient} from '@tanstack/react-query'
import {HTTP_STATUS_OK} from '../../../Constants'
import {
    QueryCRUDTypes,
    QueryKeyManager,
} from '../../../query-manager/QueryKeysManager'
import {QueryKeyTypes} from '../../../query-manager/QueryKeyTypes'
import {severityNotification} from '../../notification/NotificationConstant'
import {showNotification} from '../../notification/NotificationService'
import {
    createOrUpdateAdditionalNotifyMethod,
    deleteByIdAdditionalNotifyMethod,
    getPageAdditionalNotifyMethod,
} from '../AdditionalNotifyEndPoint'

export const useAdditionalNotifyMethod = (type, requestorId) => {
    const {additionalNotifyMethodKeys} = QueryKeyManager(
        QueryKeyTypes.additionalNotifyMethod,
        requestorId,
    )
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: data =>
            type === QueryCRUDTypes.create || type === QueryCRUDTypes.update
                ? createOrUpdateAdditionalNotifyMethod(requestorId, data)
                : type === QueryCRUDTypes.delete
                ? deleteByIdAdditionalNotifyMethod(requestorId, data)
                : data,
        onSuccess: (data, variables) => {
            if (data === HTTP_STATUS_OK || data?.id) {
                if (
                    type === QueryCRUDTypes.create ||
                    type === QueryCRUDTypes.update
                ) {
                    if (data?.content?.length > 0) {
                        showNotification(
                            severityNotification.success,
                            'Configuration Update Successfully !!',
                        )
                    }
                }
                if (type === QueryCRUDTypes.delete) {
                    showNotification(
                        severityNotification.success,
                        'Delete Successfully !!',
                    )
                }
            }
        },
    })
}

export const usePageAdditionalNotifyMethod = (
    requestorId,
    hospitalId,
    pageNumber,
    pageRows,
    sortField,
    sortOrder,
    filterRequest,
    enabled = true,
) => {
    const {additionalNotifyMethodKeys} = QueryKeyManager(
        QueryKeyTypes.additionalNotifyMethod,
        requestorId,
    )

    return useQuery({
        queryKey: additionalNotifyMethodKeys.page({
            hospitalId,
            pageNumber,
            pageRows,
            sortField,
            sortOrder,
            filterRequest,
        }),
        queryFn: () =>
            getPageAdditionalNotifyMethod(
                requestorId,
                pageNumber,
                pageRows,
                sortField,
                sortOrder,
                filterRequest,
            ),
        enabled: !!requestorId && !!enabled && !!hospitalId,
    })
}
